import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import useClasses from '../../../hooks/useClasses';
import useRoutes from '../../../hooks/useRoutes';
import { RegistrationData } from '../../../types';

import './style.scss';

interface Props {
  unitName?: string
  date: string
  registrationData: RegistrationData
}

const EarlierRegistrationsList: React.FC<Props> = ({
  unitName,
  registrationData,
  date,
}) => {
  const { buildClass } = useClasses('EarlierRegistrationsList');
  const { t } = useTranslation();
  const routes = useRoutes();
  const currentDomain = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['uiInternal', 'currentDomain', 'raw'], ''));

  const items = Object.entries(registrationData.items);

  return (
    <ul className={buildClass()}>
      {items.map(([uuid, values]) => {
        const updateLink = `${routes.dailyRegistrationUpdate.replace(':date', date)}?uuid=${uuid}`;
        const { amount } = values;
        const detailKeys = ['cost', 'where', 'with_who'];
        const details = Object.entries(values).filter(([key, value]) => (
          detailKeys.includes(key) && value
        ));

        return (
          <li className={buildClass('item')} key={uuid}>
            <Link className={buildClass('item-frequency')} to={updateLink}>
              {amount} { unitName && (
                <span className="sr-only">{unitName}</span>
              )}
            </Link>

            {details.length > 0 ? (
              <dl className={buildClass('item-details')}>
                {details.map(([key, value]) => (
                  <div key={`detail:${key}`} className={buildClass('item-details-row')}>
                    <dt className={buildClass('item-key')}>
                      {t(`pages.daily_registration.earlier_registrations.${key}`)}
                    </dt>
                    <dd className={buildClass('item-value')}>
                      {key === 'cost' ? (
                        t('pages.daily_registration.fields.cost.value', { cost: value })
                      ) : (
                        t([`pages.daily_registration.fields.${key}.values.${currentDomain}.${value}`, `pages.daily_registration.fields.${key}.values.default.${value}`])
                      )}
                    </dd>
                  </div>
                ))}
              </dl>
            ) : (
              <span className={buildClass('item-no-details')}>
                {t('pages.daily_registration.earlier_registrations.no_details')}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default EarlierRegistrationsList;
